import React, { FunctionComponent, useEffect, useState } from 'react'
import { IWorkroom } from 'Frontend/scripts/models/workrooms.model'
import {
  getAllNotHiddenWorkrooms,
  getMyWorkrooms,
  getWorkroomsByCategory,
} from 'Frontend/scripts/services/workrooms.service'
import WorkroomsListItem from './WorkroomsListItem'

interface WorkroomsListingProps {
  activeType: number
}

const WorkroomsListing: FunctionComponent<WorkroomsListingProps> = ({ activeType }) => {
  const [workRooms, setWorkRooms] = useState<IWorkroom[]>([])

  useEffect(() => {
    if (activeType == 3) {
      getAllNotHiddenWorkrooms().then((data: IWorkroom[]) => {
        setWorkRooms(data)
      })
    } else if (activeType == 2) {
      getMyWorkrooms().then((data: IWorkroom[]) => {
        setWorkRooms(data)
      })
    } else {
      getWorkroomsByCategory(activeType).then((data: IWorkroom[]) => {
        setWorkRooms(data)
      })
    }
  }, [activeType])

  return (
    <>
      <div className="d-flex flex-column gap-2">
        {workRooms.map((item: IWorkroom) => (
          <WorkroomsListItem workroom={item} key={`result-${item.id}`} />
        ))}
      </div>
    </>
  )
}
export default WorkroomsListing
